
import UserContext from '@context/UserContext';
import ProductEditForm from '@forms/ProductEdit';
import Sentry from '@integrations/Sentry';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ProductFormValues } from '@schema/ProductEditSchema';
import React, { useState } from 'react';


type ProductDialogArgs = {
  title?: string;
  userContext: UserContext;
  initialValues?: ProductFormValues;
  onSubmit: (values: guesthouse.Product) => Promise<unknown>;
  resolve: (values: ProductFormValues) => void;
  reject: (e?: Error | boolean) => void;
}

const ProductDialog: React.FC<ProductDialogArgs> = ({
  resolve,
  reject,
  userContext,
  title = 'Update product information',
  onSubmit,
  initialValues
}) => {
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);

  return (
    <UserContext.Provider value={userContext}>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>
          {title}
        </DialogTitle>

        <DialogContent>
          <ProductEditForm
            initialValues={initialValues}
            error={error}
            submitText="Save"
            onSubmit={(values) => {
              return onSubmit(values)
                .then((values) => {
                  setOpen(false);
                  return values;
                })
                .then(resolve)
                .catch(e => {
                  setError(e.message);
                  Sentry.captureException(e);
                });
            }}
          />
        </DialogContent>

        <DialogActions style={{ justifyContent: 'center' }}>
          <Button
            size="small"
            onClick={() => {
              setOpen(false);
              reject(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </UserContext.Provider>
  );
};

export default ProductDialog;
